import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { calculateDaysRemaining } from '../utils/formatters';

export const useSubscription = () => {
  const { user } = useAuth();
  const [daysRemaining, setDaysRemaining] = useState(null);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!user || !user.subscription) return;

    const days = calculateDaysRemaining(user.subscription.expiryDate);
    setDaysRemaining(days);
    setShowWarning(days !== null && days <= 5 && days > 0);
  }, [user]);

  const isActive = user?.subscription?.status === 'active';
  const isExpired = user?.subscription?.status === 'expired';
  const packageType = user?.subscription?.package;

  return {
    isActive,
    isExpired,
    packageType,
    daysRemaining,
    showWarning,
    expiryDate: user?.subscription?.expiryDate
  };
};
